import { useState } from "react";
import { Link } from "react-router-dom";

const KEY = "fsbe-consent";

export function saveConsent(stats) {
  localStorage.setItem(KEY, JSON.stringify({ stats, at: new Date().toISOString() }));
  window.dispatchEvent(new Event("fsbe-consent"));
}

export default function CookieBanner() {
  const [shown, setShown] = useState(() => !localStorage.getItem(KEY));
  if (!shown) return null;
  const choose = (v) => { saveConsent(v); setShown(false); };
  return (
    <div role="dialog" aria-label="Consentimento de cookies" className="fixed z-50 inset-x-3 bottom-[76px] lg:bottom-6 lg:left-6 lg:right-auto lg:max-w-md bg-white rounded-2xl shadow-2xl border p-5 rise" data-testid="cookie-banner">
      <p className="font-display text-lg font-bold">A sua privacidade</p>
      <p className="text-sm text-slate-700 mt-1">Usamos apenas armazenamento essencial. Com a sua autorização, recolhemos estatísticas anónimas de visitas para melhorar a Feira. <Link to="/cookies" className="underline">Saber mais</Link></p>
      <div className="flex gap-2 mt-4">
        <button onClick={() => choose(true)} className="flex-1 h-11 rounded-full bg-[var(--leaf)] text-white font-semibold" data-testid="cookie-accept-button">Aceitar</button>
        <button onClick={() => choose(false)} className="flex-1 h-11 rounded-full border font-semibold" data-testid="cookie-reject-button">Só essenciais</button>
      </div>
    </div>
  );
}
